import { render, staticRenderFns } from "./InvalidInformeDialog.vue?vue&type=template&id=0d43db34"
import script from "./InvalidInformeDialog.vue?vue&type=script&lang=js"
export * from "./InvalidInformeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports